import { useRef } from "react";
import { useDraggable } from "react-use-draggable-scroll";
import classNames from "classnames";

import styles from "./GlobalAdminsList.module.css";
import PropTypes from "prop-types";
import GlobalAdminItem from "../GlobalAdminItem";
import nextId from "react-id-generator";

/**
 *
 * List of admins with a header.
 */

export function GlobalAdminsList({ admins, onClick }) {
  const ref = useRef(); // We will use React useRef hook to reference the wrapping div:
  const { events } = useDraggable(ref, {
    applyRubberBandEffect: true,
  }); // Now we pass the reference to the useDraggable hook:
  const draggerId = "adminsDraggerId" + nextId();
  //console.log(draggerId);

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div>Name</div>
        <div>Email</div>
        <div>Admin Access</div>
      </div>
      <div className={styles.dragger} {...events} ref={ref} id={draggerId}>
        {admins.map((item, index) => (
          <div
            className={classNames(
              styles.whiteBG,
              index % 2 == 1 && styles.slightlyDarkerBackground
            )}
            key={index}
          >
            
            <GlobalAdminItem adminInfo={item} onClick={() => onClick(item)} />
          </div>
        ))}
      </div>
    </div>
  );
}

GlobalAdminsList.propTypes = {
  admins: PropTypes.arrayOf(PropTypes.object),
};
